import {useState, useEffect} from 'react'
import sortingShuffle from '../../../scripts/shuffle';
import ListenAndClick from './ListenAndClick';
import Selector from './Selector';
import ListenAndClickII from './ListenAndClickII';
import ListenAndWrite from './ListenAndWrite';
import ListenAndSpeak from './ListenAndSpeak';
import { Link } from 'react-router-dom';
import Summary from './Summary';
import 'animate.css';
import InfoButton from '../../../components/InfoButton';
import Popup from 'reactjs-popup';
import ExitButton from '../../../components/ExitButton';

const ExercisePlayer = ({id, l2, exerciseHandler, dialect=null}) => {
    const [results, setResults] = useState({})
    const [showResults, setShowResults] = useState(null)
    const [status, setStatus] = useState(null);
    const [PlayTracks, setPlayTracks] = useState([])
    const [PlayTracksNW, setPlayTracksNW] = useState([])
    const [PlayTracksNW_LS, setPlayTracksNW_LS] = useState([])
    const [PlayTracksNW_LW, setPlayTracksNW_LW] = useState([])
    const [info, setInfo] = useState({})
    const [NumOfParts, setNumOfParts] = useState(4)
    const [hideTitle, setHideTitle] = useState(false)
    const [activeTabIndex, setActiveTabIndex] = useState(0);   /*  Exercise playing */
    const [nextExercise, setNextExercise] = useState(null)
    const [showPopup, setShowPopup] = useState(false);

    // For progress bars
    const [nrExercises, setNrExercises] = useState([]) // Structure example [10,10,10,10]
    const [progress, setProgress] = useState([]) // Structure example[[1,0,1],[0],[0],[0]]

    // console.log('JOY: exercise,  level 1, block with tabs -- listen and click, listen and write etc ')

    const tabsData = [  
        {label: 'Listen & Click I', instructions:'In this listening exercise you hear two very similar words, followed by a repetition of one of these words. Can you hear which of the two words was repeated? This is called a discrimination task.'},
        {label: 'Listen & Click II', instructions: 'In this listening exercise you hear only one word. Can you hear which of the two words was said?'},
        {label: 'Listen & Speak', instructions: 'In this exercise, you first hear the tutor’s pronunciation of the word. When the bar under the recordings bar starts to run, you speak the word into the microphone. Compare your own pronunciation with that of the tutor. Not happy with your pronunciation? Press the loudspeaker button and give it another try.'},
        {label: 'Listen & Write', instructions: 'It can be hard to know how words that you hear are written. Can you write the word you hear correctly?'},
      ];

    const tabsDataNW = [  
        {label: 'Listen & Click II', instructions: 'In this listening exercise you hear only one word. Can you hear which of the two words was said?'},
        {label: 'Listen & Speak', instructions: 'In this exercise, you first hear the tutor’s pronunciation of the word. When the bar under the recordings bar starts to run, you speak the word into the microphone. Compare your own pronunciation with that of the tutor. Not happy with your pronunciation? Press the loudspeaker button and give it another try.'},
        {label: 'Listen & Write', instructions: 'It can be hard to know how words that you hear are written. Can you write the word you hear correctly?'},
    ];

    
    /*  state of tab names -- two cases. [{},{}] or NW [{},{}]*/
    const [tabs, setTabs] = useState(tabsData)
    

    // Returns label of the next exercise to be played, when when the current exercise is completed
    const findNextExercise = (progress, activeTabIdx) => {
        const length = tabs.length

        // Check from activeTabIndex to the end
        for (let idx = activeTabIdx +1 ; idx < length; idx++) {
            console.log(idx, "idx first", length, "length")
            if (progress[idx] === undefined || (progress[idx] && progress[idx].length < nrExercises[idx])) {
                setNextExercise(tabs[idx].label) 
                console.log(tabs[idx].label, "nextExercise")
                return
            }
        }

        // If no such index is found, return -1 for now. TODO?: handle this case
        return -1;
    }

    const ExerciseFooter = () => {
        return <InfoButton func={() => setShowPopup(true)} />
    }

    useEffect(() => {

        if (activeTabIndex !== tabsData.length-1 
            && progress[activeTabIndex] 
            && progress[activeTabIndex].length === nrExercises[activeTabIndex]) {
            
            setTimeout(() => {
                setHideTitle(true)
                
            }, 100);
            findNextExercise(progress, activeTabIndex)
        }
        else {
            setHideTitle(false)
        }

    }, [progress])


    useEffect(() => {

        // Sets tabs and nrExercises based on PlayTracks
        if (PlayTracks.length === 0) {
            setTabs(tabsDataNW); 
            setNumOfParts(3)
            setNrExercises([PlayTracksNW.length, PlayTracksNW.length, PlayTracksNW.length])

        }
        else if (PlayTracks.length > 0) {
            setTabs(tabsData);
            setNumOfParts(4);
            setNrExercises([PlayTracks.length, PlayTracksNW.length, PlayTracksNW.length, PlayTracksNW.length]);
        }
        else{
            setNrExercises([])
        }
    }, [PlayTracks, PlayTracksNW])


    /* fetch the data -- word-word pairs (MP), and wod-nonwod pairs -- NW*/ 
    let data_source;
    switch(l2) {
        case "English":
            data_source = `${process.env.REACT_APP_API_URL}/english/exercise/${id}`;
            break;
        case "Norwegian":
            data_source = `${process.env.REACT_APP_API_URL}/norwegian/exercise/${id}`;
            break;
        default:
            data_source = `${process.env.REACT_APP_API_URL}/exercise/${l2}/${id}`;
            break;
    }

    useEffect(()=>{
        switch(l2) {
            case "English":

                    setStatus('IN_PROGRESS');
                    try { 
                    fetch(data_source)
                        .then(response=>response.json())
                            .then(json=>{
                                setStatus('SUCCESS')
                                var tracks = [];
                                var nwproducts = [];
                                for (const lang of json.tasks) { 
                                    console.log(lang, "english lang")     
                                    if ((lang[0].audio_xpm || []).length > 0 && (lang[1].audio_xpm || []).length > 0) {                 
                                        var deal_mp = 
                                            [
                                                [   {audio : `${process.env.REACT_APP_STATIC_URL}`+ sortingShuffle(lang[0].audio_xpm)[0].replace('C:\\CalstFiles\\WordObjectContent','').replace('D:\\Workspace\\CalstFiles\\WordObjectContent',''), word : lang[0].word, translation : lang[0].translation  },
                                                    {audio : `${process.env.REACT_APP_STATIC_URL}`+ sortingShuffle(lang[1].audio_xpm)[0].replace('C:\\CalstFiles\\WordObjectContent','').replace('D:\\Workspace\\CalstFiles\\WordObjectContent',''), word : lang[1].word, translation : lang[1].translation }
                                                ], 
                                                [   {audio : `${process.env.REACT_APP_STATIC_URL}`+ sortingShuffle(lang[0].audio_xpm)[0].replace('C:\\CalstFiles\\WordObjectContent','').replace('D:\\Workspace\\CalstFiles\\WordObjectContent',''), word : lang[0].word, translation : lang[0].translation  },
                                                {audio : `${process.env.REACT_APP_STATIC_URL}`+ sortingShuffle(lang[1].audio_xpm)[0].replace('C:\\CalstFiles\\WordObjectContent','').replace('D:\\Workspace\\CalstFiles\\WordObjectContent',''), word : lang[1].word, translation : lang[1].translation }
                                                ]
                                            ]
                                            
                                        tracks.push([sortingShuffle(deal_mp[0]), sortingShuffle(deal_mp[1])[0]])
                                    }
                                }

                                // Listen & Click II / Speak / Write share the single-word ident tasks
                                for (const task of (json.nonwords || [])) {
                                    for (const w of (task || [])) {
                                        if (!w || (w.audio_xpm || []).length === 0) { continue; }
                                        let answer = String(w.target) === String(json.sound2) ? 1 : 0
                                        nwproducts.push({
                                            audio : `${process.env.REACT_APP_STATIC_URL}`+ sortingShuffle(w.audio_xpm)[0].replace('C:\\CalstFiles\\WordObjectContent','').replace('D:\\Workspace\\CalstFiles\\WordObjectContent',''),
                                            word : w.word,
                                            translation : w.translation,
                                            sound1 : json.sound1,
                                            sound2 : json.sound2,
                                            answer : answer
                                        })
                                    }
                                }

                                setPlayTracks(sortingShuffle(tracks))
                                setPlayTracksNW(sortingShuffle(nwproducts))
                                setPlayTracksNW_LS(sortingShuffle(nwproducts))
                                setPlayTracksNW_LW(sortingShuffle(nwproducts))
                                
                                
                                let info_json = {"name": json.name, "group": json.sound1, "type": null, 'id': id, "l2" : l2}
                                setInfo(info_json)
                            })
                        }
                        catch (e)
                        {
                            console.log(e, "error")
                            setStatus('FAILURE')
                        }        
                    

                break;
            case "Norwegian":

                setStatus('IN_PROGRESS');
                try { 
            
                    fetch(data_source)
                        .then(response=>response.json())
                            .then(json=>{
                                setStatus('SUCCESS')
                                var tracks = [];
                                var nwproducts = [];
                            
                                
                                var dia = dialect
                                for (const lang of ((json.dialects && json.dialects[dia.label]) || [])) { 
                                    if ((lang[0].audio_xpm || []).length > 0 && (lang[1].audio_xpm || []).length > 0)   {             
                                        var deal_mp = 
                                            [
                                                [   {audio : `${process.env.REACT_APP_STATIC_URL}`+ sortingShuffle(lang[0].audio_xpm)[0].replace('C:\\CalstFiles\\WordObjectContent','').replace('D:\\Workspace\\CalstFiles\\WordObjectContent',''), word : lang[0].word, translation : lang[0].translation  },
                                                    {audio : `${process.env.REACT_APP_STATIC_URL}`+ sortingShuffle(lang[1].audio_xpm)[0].replace('C:\\CalstFiles\\WordObjectContent','').replace('D:\\Workspace\\CalstFiles\\WordObjectContent',''), word : lang[1].word, translation : lang[1].translation }
                                                ], 
                                                [   {audio : `${process.env.REACT_APP_STATIC_URL}`+ sortingShuffle(lang[0].audio_xpm)[0].replace('C:\\CalstFiles\\WordObjectContent','').replace('D:\\Workspace\\CalstFiles\\WordObjectContent',''), word : lang[0].word, translation : lang[0].translation  },
                                                {audio : `${process.env.REACT_APP_STATIC_URL}`+ sortingShuffle(lang[1].audio_xpm)[0].replace('C:\\CalstFiles\\WordObjectContent','').replace('D:\\Workspace\\CalstFiles\\WordObjectContent',''), word : lang[1].word, translation : lang[1].translation }
                                                ]
                                            ]
                                        tracks.push([sortingShuffle(deal_mp[0]), sortingShuffle(deal_mp[1])[0]])
                                    };
                                };

                                // Listen & Click II / Speak / Write share the single-word ident tasks
                                for (const task of ((json.nonword_dialects && json.nonword_dialects[dia.label]) || [])) {
                                    for (const w of (task || [])) {
                                        if (!w || (w.audio_xpm || []).length === 0) { continue; }
                                        let answer = String(w.target) === String(json.sound2) ? 1 : 0
                                        nwproducts.push({
                                            audio : `${process.env.REACT_APP_STATIC_URL}`+ sortingShuffle(w.audio_xpm)[0].replace('C:\\CalstFiles\\WordObjectContent','').replace('D:\\Workspace\\CalstFiles\\WordObjectContent',''),
                                            word : w.word,
                                            translation : w.translation,
                                            sound1 : json.sound1,
                                            sound2 : json.sound2,
                                            answer : answer
                                        })
                                    }
                                };
                                let info_json = {"name": json.name, "group": json.sound1, "type": null,  'id': id, "l2" : l2}

                                setPlayTracks(tracks);
                                setPlayTracksNW(nwproducts);
                                setPlayTracksNW_LS(sortingShuffle(nwproducts))
                                setPlayTracksNW_LW(sortingShuffle(nwproducts))
                                setInfo(info_json);
                                setNrExercises([tracks.length, nwproducts.length, nwproducts.length, nwproducts.length])
                                    // tracks lengths of the exercises
                                console.log(nrExercises, "nrex")
                            })    
                    }
                    catch (e)
                    { 
                        setStatus('FAILURE')
                    }        

                break;
            default:

                    setStatus('IN_PROGRESS');
                    try { 
                        fetch(data_source)
                        .then(response=>response.json())
                            .then(json=>{
                    
                                var tracks = [];
                                for (const lang of (json.tasks || [])) {                       
                                    var deal = sortingShuffle(
                                        [
                                            [   {audio : `${process.env.REACT_APP_STATIC_URL}`+ sortingShuffle(lang[0].audio_xpm || [])[0], word : lang[0].word, translation : lang[0].translation  },
                                                {audio : `${process.env.REACT_APP_STATIC_URL}`+ sortingShuffle(lang[1].audio_xpm || [])[0], word : lang[1].word, translation : lang[1].translation  }
                                            ], 
                                            [   {audio : `${process.env.REACT_APP_STATIC_URL}`+sortingShuffle(lang[1].audio_cpm || [])[0], word : lang[1].word, translation : lang[1].translation   },
                                                {audio : `${process.env.REACT_APP_STATIC_URL}`+sortingShuffle(lang[0].audio_cpm || [])[0], word : lang[0].word, translation : lang[0].translation   }
                                            ]
                                        ]
                                        )
                                    tracks.push([sortingShuffle(deal[0]), sortingShuffle(deal[1])[0]])

                                }
                                setPlayTracks(sortingShuffle(tracks))
                                
                                console.log(PlayTracks, "PlayTracks")
                                
                                
                                var nwproducts = [];
                                for (const task of (json.nonwords || [])) {
                                    for (const w of (task || [])) {
                                        if (!w || (w.audio_xpm || []).length === 0) { continue; }
                                        let answer = String(w.target) === String(json.sound2) ? 1 : 0
                                        nwproducts.push({
                                            audio : `${process.env.REACT_APP_STATIC_URL}`+ sortingShuffle(w.audio_xpm)[0],
                                            word : w.word,
                                            translation : w.translation,
                                            sound1 : json.sound1,
                                            sound2 : json.sound2,
                                            answer : answer
                                        })
                                    }
                                }
                                
                            
                                setPlayTracksNW(sortingShuffle(nwproducts))
                                setPlayTracksNW_LS(sortingShuffle(nwproducts))
                                setPlayTracksNW_LW(sortingShuffle(nwproducts))
                                console.log(json.Exercise_information);
                                setInfo({
                                    "name": json.name,
                                    "group": json.sound1,
                                    "type": json.Type_description,
                                    'id': id,
                                    "l2" : l2,
                                    "info": json.info
                                })
                                setStatus('SUCCESS')
                            
                            })  
                        }
                    catch (e)
                        {
                            setStatus('FAILURE')
                        
                        }       
                            

                break;
        }
    },[id, l2, dialect]) 



  return (

    (status === "SUCCESS") ?

            <div className="flex flex-grow flex-col">
             
                
                
                {showResults ?                  
                <div className="flex flex-col">
                    <Summary 
                    sum={results}
                    parts={NumOfParts} 
                    info={info}
                    backToExercises={(state) => {
                        setShowResults(state);
                        setResults({})
                        setActiveTabIndex(0)
                        
                        
                    }}
                    
                    />
                </div>
               :
                <div>
                    <Selector 
                        clickHandler={(tab_index) =>
                                {
                                    

                                    setActiveTabIndex(tab_index);
                                }
                        } 
                        tabsData={tabs} 
                        active = {activeTabIndex}

                        exerciseHandler={exerciseHandler} 
                        progress={progress}
                        setProgress={setProgress} 
                        nrExercises={nrExercises}
                    
                    />

                    
                     {/* Title */}
                    <div className='hidden px-5 pt-6 text-center md:block'>
                        <div className={`font-serif text-3xl font-bold tracking-tight text-cyan-950 animate__animated
                            ${
                                hideTitle ? 'hidden' : ''
                            }`}>
                            {tabs[activeTabIndex].label.startsWith('Listen & Click') ? 'Listen & Click' : tabs[activeTabIndex].label}
                        </div>                      
                    </div>

                    {/* Exercises */}
                    <div className='exercise-stage grow'>
                        <Popup open={showPopup}>
                            <div className='max-w-lg rounded-2xl border border-slate-200 bg-white p-5 shadow-xl'>
                                <div className="mb-4 flex justify-end"><ExitButton func={() => setShowPopup(false)} /></div>
                                <div className="leading-7 text-slate-700">{info.info}</div>
                            </div>
                        </Popup>
                    
                        {(tabs[activeTabIndex].label === 'Listen & Click I' && PlayTracks.length > 0 )&&     
                                
                            <ListenAndClick 
                            tracks={PlayTracks} 
                            info={info} 
                            resultsHandler={(state) =>
                                {
                                    if (results)
                                        { 
                                            results['ListenAndClick'] = state
                                            setResults(results);
                                        }
                                    else
                                        {
                                            setResults({'ListenAndClick': state});
                                        };
                                } 
                            }
                            nextTab = {(tab) =>
                                {
                                    setActiveTabIndex(tabs.findIndex((element) => element.label === tab))
                                }
                            }
                            nextExercise = {nextExercise}
                            
                            // for progress bar
                            progress={progress} 
                            setProgress={setProgress} 
                            tab={activeTabIndex} 
                            />
                                
                        }
                            
                        {(tabs[activeTabIndex].label === 'Listen & Click II' && PlayTracksNW.length > 0 ) &&
                                
                            
                            <ListenAndClickII   
                            tracks={PlayTracksNW} 
                            resultsHandler={(state) =>
                                {
                                    if (results)
                                        { 
                                            
                                            results['ListenAndClickII'] = state
                                            setResults(results);
                                        }
                                    else
                                        {
                                            setResults({'ListenAndClickII': state});
                                        };
                                } 
                            } 
                            nextTab = {(tab) =>
                                {
                                    setActiveTabIndex(tabs.findIndex((element) => element.label === tab))
                                }
                            }
                            nextExercise = {nextExercise}

                            // for progress bar
                            progress={progress} 
                            setProgress={setProgress} 
                            tab={activeTabIndex} 
                                />
                                
                        }
    
    
                                    
                        
                        
                        {(tabs[activeTabIndex].label === 'Listen & Speak' && PlayTracksNW.length > 0)&&    
                                
                            <ListenAndSpeak 
                            tracks={PlayTracksNW_LS} 
                            resultsHandler={(state) =>
                                {
                                    if (results)
                                        { 
                                        
                                            results['ListenAndSpeak'] = state
                                            setResults(results);
                                        }
                                    else
                                        {
                                            setResults({'ListenAndSpeak': state});
                                        };
                                } 
                            } 
                            nextTab = {(tab) =>
                                {
                                    setActiveTabIndex(tabs.findIndex((element) => element.label === tab))
                                }
                            }
                            nextExercise = {nextExercise}

                            // for the progress bar
                            progress={progress} 
                            setProgress={setProgress} 
                            tab={activeTabIndex} 
                            
                            
                            />
                                
                        }

                        {(tabs[activeTabIndex].label === 'Listen & Write' && PlayTracksNW.length > 0)&&    
                                
                            <ListenAndWrite 
                            tracks={PlayTracksNW_LW}  
                            resultsHandler={(state) =>
                            {
                                if (results)
                                    { 
                                        results['ListenAndWrite'] = state
                                        setResults(results);
                                    }
                                else
                                    {
                                        setResults({'ListenAndWrite': state});
                                    };
                                } 
                            } 
                            showResultsHandler = {(state) => 
                                {
                                    setShowResults(state);
                                }
                            }

                            // for progress bar
                            progress={progress} 
                            setProgress={setProgress} 
                            tab={activeTabIndex} 
                                />
                                    
                        }
                            
                    </div>
                    {info.info && <ExerciseFooter/>}
                    
                    <button
                    className={`sticky bottom-0 w-full border-t border-slate-200 bg-white/95 py-3 text-xs font-extrabold tracking-[0.25em] text-slate-500 backdrop-blur md:hidden
                    ${showResults ? 'hidden' : ''}
                    `}
                    onClick={() => 
                        activeTabIndex + 1 === tabs.length ? 
                        setShowResults(true)  
                        :setActiveTabIndex(activeTabIndex + 1)
                    }
                    >
                        S K I P <p className='font-normal tracking-normal'>{tabs[activeTabIndex].label}</p>
                    </button>
                </div>
                }

                
            </div>
            :    
                 
             
            (status === "FAILURE") ? 
                <div className='border-2 flex flex-col'>
                    <div    className='mx-auto text-xl text-red-500'>Error with data catching, check</div>
                    <Link   className='border-2  rounded-md p-2 mx-auto text-red-500 text-2xl' 
                            to={`${process.env.REACT_APP_API_URL}/exercise_raw/${l2}/${id}`} 
                            target="_blank"
                    >
                        the raw data
                    </Link>
                </div>
            : 
                <div className='flex flex-col mx-auto text-md'>Loading...</div>
              
    )
}


export default ExercisePlayer;
